import Link from "ds/components/Link";

import { CellComponentProps } from "../types";
import useIdpGroupRolesListAnalytics from "../useIdpGroupRolesListAnalytics";

type IdpGroupRolesListItemGrantedAtCellProps = CellComponentProps;

const IdpGroupRolesListItemGrantedAtCell = ({
  roleBinding,
}: IdpGroupRolesListItemGrantedAtCellProps) => {
  const trackAnalytics = useIdpGroupRolesListAnalytics();

  return (
    <Link
      size="small"
      href={`/spaces/${roleBinding.space.id}`}
      onPress={() => trackAnalytics("Space link clicked")}
    >
      {roleBinding.space.name}
    </Link>
  );
};

export default IdpGroupRolesListItemGrantedAtCell;
